import React from 'react';
import { Pane, Strong, Text } from 'evergreen-ui';

export default function JsonParameters({ parameters }: { parameters: string | object }) {
  const parsedParameters = typeof parameters === 'string' ? JSON.parse(parameters) : parameters;
  return (
    <Pane display="grid" gridTemplateRows="max-content 1fr" rowGap=".5rem">
      <Strong>Параметы</Strong>
      <Pane display="grid" gridAutoFlow="row" gridAutoRows="max-content" border>
        {
          Object.keys(parsedParameters).map((key, index, arr) => (
            <Pane key={key} display="grid" gridTemplateColumns="1fr 1fr" borderBottom={index !== arr.length - 1}>
              <Strong padding={8} borderRight="1px solid #e4e7eb">{key}</Strong>
              <Text padding={8}>{parsedParameters[key]}</Text>
            </Pane>
          ))
        }
      </Pane>
    </Pane>
  );
}
